<template>
  <table-list
      :height="height"
      :data="tableData"
      :searchParams="searchParams"
      :request-params="{status: 'draft'}"
      :auto="false"
      @query="handleLoadList"
      @selection-change="selection = $event"
      ref="list">
    <el-table-column type="selection" width="50"/>

    <el-table-column :label="$t('编号')" align="center" prop="num" fixed="left"  sortable min-width="150" />
    <el-table-column :label="$t('图片')" align="center" prop="cover" min-width="150">
      <template v-slot="{row}">
        <div class="fb-gap-10">
          <preview-img :img-url="row.cover" :size="40" :length="2" />
        </div>
      </template>
    </el-table-column>
    <el-table-column :label="$t('名称')" align="center" prop="name" show-overflow-tooltip />
    <el-table-column :label="$t('分类')" align="center" prop="sortName" min-width="130" />
    <el-table-column :label="$t('发布者编号')" align="center" prop="userNum" sortable min-width="140"/>
    <el-table-column :label="$t('发布者昵称')" align="center" prop="username" show-overflow-tooltip  min-width="160"/>
    <el-table-column :label="$t('会员等级')" align="center" prop="vipLevelName"  min-width="160"/>
    <el-table-column :label="$t('用户状态')" align="center"  min-width="130">
      <template v-slot="{row}">
        <dict-text dict-flag="AN_USER_STATUS" :status="row.userBandStatus" />
      </template>
    </el-table-column>
    <el-table-column :label="$t('菜谱属性')" align="center"  min-width="130">
      <template v-slot="{row}">
        <dict-text :status="row.property" dict-flag="RECIPE_ATTRS" />
      </template>
    </el-table-column>
    <el-table-column :label="$t('能量值')" align="center" prop="calorie"  min-width="130" />
    <el-table-column :label="$t('相似菜谱数')" align="center" min-width="170" prop="sameCount" sortable >
      <template v-slot="{row}">
        <el-link type="primary" :underline="false" @click="handleSimilarRecipe(row)">{{ row.sameCount || 0 }}</el-link>
      </template>
    </el-table-column>
    <el-table-column :label="$t('收藏次数')" align="center" prop="collectCount"  sortable min-width="120"/>
    <el-table-column :label="$t('观看次数')" align="center" prop="watchCount"  sortable min-width="120"/>
    <el-table-column :label="$t('评论次数')" align="center" prop="commentCount" sortable  min-width="120"/>
    <el-table-column :label="$t('制作次数')" align="center" prop="cookCount" sortable  min-width="150"/>
    <el-table-column :label="$t('综合评分')" align="center" prop="star" sortable min-width="120"/>
    <el-table-column :label="$t('是否推荐')" align="center" prop="recommend" sortable min-width="150">
      <template v-slot="{row}">
        <dict-text :status="row.recommend" dict-flag="RECIPE_IS_RECOMMEND" />
      </template>
    </el-table-column>
    <el-table-column :label="$t('使用国家')" align="center" min-width="130" />
    <el-table-column :label="$t('发布时间')" align="center" show-overflow-tooltip min-width="200">
      <template v-slot="{row}">
        {{row.createTime | formatDate}}
      </template>
    </el-table-column>
    <el-table-column :label="$t('操作')" align="center" min-width="150" fixed="right">
      <template v-slot="{row}">
        <el-dropdown size="small">
          <el-button type="primary" size="small">
            {{ $t('更多操作') }}<i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item divided  @click.native="handleCheckRecipe(row)">{{ $t('查看') }}</el-dropdown-item>
            <el-dropdown-item divided @click.native="handleChangeRecommend(row)">{{row.recommend === "yes" ? $t('取消推荐'): $t('设为推荐')}}</el-dropdown-item>
            <el-dropdown-item divided @click.native="$router.push('/recipe-cmt/list?num=' + row.num)">{{ $t('菜谱评论') }}</el-dropdown-item>
            <el-dropdown-item divided @click.native="$router.push('/income/list?num=' + row.num)">{{ $t('收入记录') }}</el-dropdown-item>
            <el-dropdown-item divided @click.native="handleChangeStatus(row)">{{ $t('上架') }}</el-dropdown-item>
            <el-dropdown-item divided @click.native="handleDeleteRecipe(row)" >{{ $t('删除') }}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </template>
    </el-table-column>
  </table-list>
</template>

<script>
import TableList from "@/components/table-list/TableList";
import {request, requestByTip} from "@/config/request";
import DictText from "@/components/dict/DictText";
import recipe_mixin from "@/mixin/recipe_mixin";
import PreviewImg from "@/components/preview-img/PreviewImg.vue";
export default {
  name: "StoreRecipe",
  components: {PreviewImg, DictText, TableList},
  mixins: [recipe_mixin],
  props: {
    onLoad: {
      type: Function,
      default: () => {}
    },
    searchParams: {
      type: Object,
      default: () => {
        return {}
      }
    },
    current: {
      type: String,
      default: ""
    },
    height: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      tableData: [],
      selection: []
    }
  },
  methods: {
    handleSearch() {
      this.$refs.list.handleSearch();
    },


    // 设置上架
    async handleChangeStatus(row) {
      try {
        let params = {
          num: row.num,
          status: 'audit', // 上架前需提交到审核，审核通过后自动上架
        }
        await requestByTip(this.$api.cookbook.updateStatus,
            params, {}, {message: this.$t('是否上架？')});
        this.$message.success(this.$t('操作成功'));
        this.$refs.list.handleRequest();
      }catch(e) {
         console.log(e);
      }
    },


    // 设置为推荐
    async handleChangeRecommend(row) {
      try {
        let params = {
          num: row.num,
          status: "store",
          recommend: row.recommend === 'yes' ? "no" : 'yes',
        }
        let message = row.recommend === 'yes' ? this.$t('是否取消推荐？') : this.$t('是否设置为推荐？')
        await requestByTip(this.$api.cookbook.updateStatus,
            params, {}, {message});
        this.$message.success(this.$t('操作成功'));
        this.$refs.list.handleRequest();
      }catch(e) {
         console.log(e);
      }
    },


    async handleLoadList(params, setTotal) {
      try {
        if(Array.isArray(params.firstTypeCode)) params.firstTypeCode = params.firstTypeCode.join(",");
        let res = await request(this.$api.cookbook.list, params);
        this.tableData = res.cookbooks.map(item => {
          item.coverList = item.cover ? item.cover.split(",") : [];
          item.star = item.star ? item.star.toFixed(2) : 0;
          return item;
        })
        setTotal(res.pager?.itemCount);
      } catch (e) {
        console.error(e);
      }
    },

    // 审核
    async handleAudit() {
      try {
        let res = await requestByTip(this.$api.test.list);
        console.log('res', res);
      }catch(e) {
        console.log(e);
      }
    }
  },
  watch: {
    current: {
      handler(val) {
        if(val === "StoreRecipe") {
          this.$nextTick(() => {
            this.$refs.list.handleRequest();
          })
        }
      },
      immediate: true,
    }
  }
}
</script>

<style scoped>

</style>
